module.exports = __webpack_public_path__ + "static/img/webpic001.949b94d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webpic001.jpg
// module id = 7VAF
// module chunks = 1